var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 68,
    height: 68,
    rx: 34,
    stroke: "#FFFAEB",
    strokeWidth: 11.3333
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#FEE4E2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 68,
    height: 68,
    rx: 34,
    stroke: "#FEF3F2",
    strokeWidth: 11.3333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1667 31.5026V30.3693C46.1667 28.7825 46.1667 27.989 45.8579 27.383C45.5862 26.8498 45.1528 26.4164 44.6196 26.1448C44.0136 25.8359 43.2201 25.8359 41.6333 25.8359H39.3667C37.7799 25.8359 36.9864 25.8359 36.3804 26.1448C35.8472 26.4164 35.4138 26.8498 35.1421 27.383C34.8333 27.989 34.8333 28.7825 34.8333 30.3693V31.5026M37.6667 39.2943V46.3776M43.3333 39.2943V46.3776M27.75 31.5026H53.25M50.4167 31.5026V47.3693C50.4167 49.7495 50.4167 50.9396 49.9534 51.8487C49.546 52.6484 48.8958 53.2986 48.0961 53.706C47.187 54.1693 45.9969 54.1693 43.6167 54.1693H37.3833C35.0031 54.1693 33.813 54.1693 32.9039 53.706C32.1042 53.2986 31.454 52.6484 31.0466 51.8487C30.5833 50.9396 30.5833 49.7495 30.5833 47.3693V31.5026",
    stroke: "#D92D20",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#D1FADF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 68,
    height: 68,
    rx: 34,
    stroke: "#ECFDF3",
    strokeWidth: 11.3333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1249 40.0026L38.3749 44.2526L46.8749 35.7526M54.6666 40.0026C54.6666 47.8266 48.324 54.1693 40.4999 54.1693C32.6759 54.1693 26.3333 47.8266 26.3333 40.0026C26.3333 32.1786 32.6759 25.8359 40.4999 25.8359C48.324 25.8359 54.6666 32.1786 54.6666 40.0026Z",
    stroke: "#039855",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickImage);
export default __webpack_public_path__ + "static/media/tickImage.c531f4c626dc48ba659505dad6612f27.svg";
export { ForwardRef as ReactComponent };